import { View } from "@/components/ui/view";
import React from 'react';
import LoadFlow from '../components/flow/LoadFlow';
import { ReactFlowProvider } from 'reactflow';
import { useSelector } from "react-redux";

// ---
import { switchScreen } from '../../hooks/navigate';
// ---

export default function Editor({ navigation, route }) {

    console.log('XXX 0', route.params)
    // ---
    // FIXME(@Milo): A lookup using the local workflow ID should be the standard
    // way, but some navigations pass the entire `workflow` object instead.
    //
    // This setup still allows initialization with an object, but it redirects to
    // the UUID to prevent showing "[Object object]" in the URL. Ideally, in the
    // future, only the ID would be used to access this view and this check removed.
    if (route.params?.workflow instanceof Object) {
        switchScreen(navigation, 'editor', { k: route.params?.workflow?.id });
        return <></>
    }
    // ---

    const workflow =  useSelector((state) => state.workflows)[route.params?.k]
    const studio =  useSelector((state) => state.studio).find(task => task.id == route.params?.k)
    console.log('XXX 1', workflow)
    console.log('XXX 2', studio)
    return (
        <ReactFlowProvider>
            <View className="flex-1 m-4">
                <LoadFlow navigation={navigation} workflow={workflow || studio} />
            </View>
        </ReactFlowProvider>
    );
}
